import {
  UPDATE_PLC_SAFETY_TRIGGER,
  UPDATE_PLC_SAFETY_TRIGGER_SUCCESSFUL,
  UPDATE_PLC_SAFETY_TRIGGER_FAILED,
} from './actionTypes';

const initialState = {
  updatePlcSafetyTriggerError: null,
  messagePlcSafetyTrigger: null,
  loadingUpdatePlcSafetyTrigger: false,
};

const updateTrigger = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PLC_SAFETY_TRIGGER:
      state = { ...state, loadingUpdatePlcSafetyTrigger: true, updatePlcSafetyTriggerError: null };
      break;
    case UPDATE_PLC_SAFETY_TRIGGER_SUCCESSFUL:
      state = {
        ...state,
        loadingUpdatePlcSafetyTrigger: false,
        messagePlcSafetyTrigger: action.payload,
        updatePlcSafetyTriggerError: null,
      };
      break;
    case UPDATE_PLC_SAFETY_TRIGGER_FAILED:
      state = {
        ...state,
        messagePlcSafetyTrigger: null,
        loadingUpdatePlcSafetyTrigger: false,
        updatePlcSafetyTriggerError: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default updateTrigger;
